export const requiredData = [
    { id: 1, inputTitle: 'این فیلد الزامی است.' },
    { id: 2, inputTitle: 'حداقل یک فیلد مورد نیاز است.' },
]


export const formErrorsData = [
    { id: 3, inputTitle: 'متاسفیم! فقط یک بار ورود مجاز است. ارسال چندگانه برای این فرم غیرفعال است.' },
    { id: 4, inputTitle: 'اشکالاتی در فرم وجود دارد. لطفا قبل از ادامه آنها را اصلاح کنید.' },
    { id: 5, inputTitle: 'خطاهایی در این صفحه وجود دارد. لطفا قبل از ادامه آنها را اصلاح کنید.' },
    { id: 6, inputTitle: 'فیلدهای الزامی ناقص وجود دارد. لطفا آنها را تکمیل کنید.' },
]


export const validateData = [
    { id: 7, inputTitle: 'این فیلد فقط می تواند شامل حروف باشد' },
    { id: 8, inputTitle: 'این فیلد فقط می تواند حاوی نویسه های سیریلیک باشد' },
    { id: 9, inputTitle: 'این فیلد فقط می تواند حاوی یک URL معتبر باشد' },
    { id: 10, inputTitle: 'این فیلد فقط می تواند حاوی مقادیر عددی باشد' },
    { id: 11, inputTitle: 'این قسمت فقط می تواند شامل حروف و اعداد باشد.' },
    { id: 12, inputTitle: 'این فیلد فقط می تواند حاوی مقادیر ارز باشد.' },
    { id: 13, inputTitle: 'مقدار فیلد باید ماسک را پر کند.' },
    { id: 14, inputTitle: 'تعداد کاراکترها نباید از حداقل مقدار کمتر باشد:' },
    { id: 15, inputTitle: 'زمان معتبری وارد کنید' },
]


export const textareaData = [
    { id: 16, inputTitle: 'محدودیت این است که ، کلمات زیادی هستند' },
    { id: 17, inputTitle: 'کلمات بسیار کم است' },
    { id: 18, inputTitle: 'تعداد کاراکترها بسیار زیاد است' },
    { id: 19, inputTitle: 'تعداد کاراکترها بسیار کم است' },
]

export const emialData = [
    { id: 20, inputTitle: 'یک آدرس ایمیل معتبر وارد کنید' },
    { id: 21, inputTitle: 'ایمیل مطابقت ندارد' },
    { id: 22, inputTitle: 'حساب های ایمیل رایگان مجاز نیستند' },
    { id: 23, inputTitle: 'شما باید این ایمیل را تایید کنید' },
]

export const radioData = [
    { id: 24, inputTitle: 'حداقل تعداد مورد نیاز را انتخاب کنید' },
    { id: 25, inputTitle: 'حداکثر تعداد مورد نیاز مجاز است' },
]


export const numberData = [
    { id: 26, inputTitle: 'ورودی نباید کمتر از حداقل مقدار باشد:' },
    { id: 27, inputTitle: 'ورودی نباید از حداکثر مقدار بیشتر باشد:' },
    { id: 28, inputTitle: 'حداکثر رقم مجاز است' },
]


export const dateData = [
    { id: 29, inputTitle: 'تاریخ نباید در گذشته باشد.' },
    { id: 30, inputTitle: 'این تاریخ در دسترس نیست.' },
    { id: 31, inputTitle: 'این تاریخ معتبر نیست. قالب تاریخ {yyyy/mm/dd} است' },
    { id: 32, inputTitle: 'این تاریخ معتبر نیست. یک تاریخ معتبر وارد کنید.' },
    { id: 33, inputTitle: 'برای ارسال این فرم باید بیش از {minAge} سال سن داشته باشید.' },
]


export const uploadData = [
    { id: 34, inputTitle: 'پسوند {file} نامعتبر است. فقط {extensions} مجاز است.' },
    { id: 35, inputTitle: '{file} خیلی بزرگ است، حداکثر اندازه فایل {sizeLimit} است.' },
    { id: 36, inputTitle: '{file} خیلی کوچک است، حداقل اندازه فایل {minSizeLimit} است.' },
    { id: 37, inputTitle: '{file} خالی است، لطفاً دوباره فایل‌ها را بدون آن انتخاب کنید.' },
    { id: 38, inputTitle: 'آپلود فایل انجام نشد، لطفا آن را حذف کنید و دوباره فایل را آپلود کنید.' },
    { id: 39, inputTitle: 'فایل ها در حال آپلود هستند، اگر اکنون از آنجا خارج شوید، آپلود لغو می شود.' },
    { id: 40, inputTitle: 'فقط آپلود فایل {fileLimit} مجاز است.' },
    { id: 41, inputTitle: 'فایل ها را در اینجا بکشید و رها کنید' },
    { id: 42, inputTitle: 'حداکثر حجم فایل' },
    { id: 43, inputTitle: 'یک فایل را انتخاب کنید' },
]


export const matrixData = [
    { id: 44, inputTitle: 'حداقل یک فیلد مورد نیاز است.' },
    { id: 45, inputTitle: 'هر ردیف مورد نیاز است.' },
    { id: 46, inputTitle: 'هر سلول مورد نیاز است.' },
]


export const appointmentData = [
    { id: 47, inputTitle: 'زمان انتخاب شده' },
    { id: 48, inputTitle: 'زمان سابق' },
    { id: 49, inputTitle: 'لغو قرار' },
    { id: 50, inputTitle: 'لغو انتخاب' },
    { id: 51, inputTitle: 'بازه زمانی موجود نیست' },
    { id: 52, inputTitle: '{time} در {date} گرفته شده است. لطفا یک بازه زمانی دیگر انتخاب کنید.' },
]


export const paymentData = [
    { id: 53, inputTitle: 'شماره کارت اعتباری نامعتبر است.' },
    { id: 54, inputTitle: 'شماره CVC نامعتبر است.' },
    { id: 55, inputTitle: 'تاریخ انقضا نامعتبر است.' },
    { id: 56, inputTitle: 'لطفا مشخصات کارت اعتباری را پر کنید.' },
    { id: 57, inputTitle: 'لطفا حداقل یک کالا را برگزینید.' },
    { id: 58, inputTitle: 'لطفا مقادیر عددی را برای مبلغ کمک وارد کنید.' },
    { id: 59, inputTitle: 'لطفا یک عدد کامل وارد کنید' },
    { id: 60, inputTitle: 'حداقل مقدار {minAmount} {currency} است' },
    { id: 61, inputTitle: 'موجودی کافی برای انتخاب فعلی وجود ندارد' },
    { id: 62, inputTitle: 'موجودی کافی برای انتخاب فعلی موجود نیست ({count} مورد باقی مانده است)' },
    { id: 63, inputTitle: 'فروخته شده' },
    { id: 64, inputTitle: 'فروخته شد' },
    { id: 65, inputTitle: 'انتخاب فروخته شد' },
    { id: 66, inputTitle: '({count} مورد باقی مانده است)' },
]

export const submitData = [
    { id: 67, inputTitle: 'لطفا صبر کنید...' },
    { id: 68, inputTitle: 'آیا مطمئن هستید که می خواهید فرم را پاک کنید؟' },
]

export const otherData = [
    { id: 69, inputTitle: 'امتیاز شما باید کمتر یا مساوی باشد' },
    { id: 70, inputTitle: 'کل امتیاز فقط باید کمتر یا مساوی باشد' },
]

export const progressData = [
    { id: 71, inputTitle: 'مشاهده همه' },
    { id: 72, inputTitle: 'از' },
]

export const reviewData = [
    { id: 73, inputTitle: 'بررسی و ارسال کنید' },
    { id: 74, inputTitle: 'بازگشت به فرم' },
]

export const accessibilityData = [
    { id: 75, inputTitle: 'تمام فیلدهایی که با * مشخص شده اند الزامی هستند و باید پر شوند.' },
    { id: 76, inputTitle: 'فیلد خطا دارد' },
    { id: 77, inputTitle: 'خطا' },
]

export const navigationData = [
    { id: 78, inputTitle: 'در این صفحه {count} خطا وجود دارد. لطفا قبل از حرکت آنها را اصلاح کنید.' },
    { id: 79, inputTitle: 'خطای {count} در این صفحه وجود دارد. لطفا قبل از ادامه آن را اصلاح کنید.' },
    { id: 80, inputTitle: 'آفرین! تمام خطاها رفع شده است.' },
]